import axiosInstance from "../../../utils/axios";
import { GET_LOANS, GET_SETTLEMENTS, GET_ERRORS } from "../actions/types";
import { tokenConfig } from "./auth";

export const getLoans = () => (dispatch, getState) => {
  axiosInstance
    .get("loans?populate=*", tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: GET_LOANS,
        payload: res.data.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response,
      });
    });
};

export const getSettlements = () => (dispatch, getState) => {
  axiosInstance
    .get("settlements?populate=*", tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: GET_SETTLEMENTS,
        payload: res.data.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response,
      });
    });
};
